import * as React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { IgloohomeLockFromIgloohomeService } from '../../../../../api/PropertyIntegration';
import FormSelectLabeled from '../../../../common/form/SelectLabeled';
import { useState } from 'react';
import Button from '../../../../common/form/Button';
import FormInput from '../../../../common/form/Input';

interface Props {
    availableLocksFromIgloohomeService: Array<IgloohomeLockFromIgloohomeService>;
    addLock: (lockUniqueId: string, lockName: string, displayName: string) => void;
}

const IgloohomeSelectLockRow = (props: Props) => {
    const [selectedLockUniqueId, setSelectedLockUniqueId] = useState<string | undefined>(undefined);
    const [alternateLockName, setAlternateLockName] = useState<string>('');
    const [alternateDisplayName, setAlternateDisplayName] = useState<string>('');

    const handleSubmit = () => {
        if (!selectedLockUniqueId || !props.availableLocksFromIgloohomeService) {
            return;
        }

        const submittedLock = props.availableLocksFromIgloohomeService.find(
            lock => lock.id === selectedLockUniqueId
        );

        if (submittedLock === undefined) {
            return;
        }

        props.addLock(
            selectedLockUniqueId,
            alternateLockName === '' ? submittedLock.name : alternateLockName,
            alternateDisplayName === '' ? submittedLock.displayName : alternateDisplayName
        );

        setAlternateLockName('');
        setSelectedLockUniqueId(undefined);
    };

    return (
        <Row className="code-row">
            <Col md={3}>
                <div>
                    <FormSelectLabeled
                        selectProps={{
                            name: 'lockSelect',
                            id: 'lock-select',
                            value: selectedLockUniqueId
                        }}
                        onChange={(_name, value) =>
                            typeof value === 'string' ? setSelectedLockUniqueId(value) : undefined
                        }
                        selectOptions={props.availableLocksFromIgloohomeService.map(lock => ({
                            label: lock.name,
                            value: lock.id
                        }))}
                        labelProps={{ labelText: 'Add lock' }}
                    />
                </div>
            </Col>
            <Col md={3}>
                <div>
                    <FormInput
                        labelProps={{ labelText: 'Display Name' }}
                        inputProps={{
                            id: 'display-rename',
                            name: 'displayRename',
                            value: alternateDisplayName,
                            placeholder: 'Unit 123'
                        }}
                        onChange={(_name, value) => setAlternateDisplayName(value.toString())}
                    />
                </div>
            </Col>
            <Col md={3}>
                <div>
                    <FormInput
                        labelProps={{ labelText: 'Lock Name' }}
                        inputProps={{
                            id: 'lock-rename',
                            name: 'lockRename',
                            value: alternateLockName,
                            placeholder: 'Unit 123'
                        }}
                        onChange={(_name, value) => setAlternateLockName(value.toString())}
                    />
                </div>
            </Col>
            <Col md={3}>
                <div className="add-lock-button">
                    <Button
                        addlClassName="btn-primary form-group"
                        text={'Add Lock'}
                        suppressBottomMargin={true}
                        onClick={handleSubmit}
                        disabled={selectedLockUniqueId === undefined}
                    />
                </div>
            </Col>
        </Row>
    );
};

export default IgloohomeSelectLockRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/IgloohomeSelectLockRow.tsx